import ff from './ff';

export default class c51d {

static d_defs = {

/*
  DROP TABLE t_c51r;
  CREATE TABLE t_c51r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c51rb21f INTEGER,
    c51rb51k INTEGER,
    c51rc11s TEXT,
    c51ri11s TEXT,
    c51rcx1i INTEGER,
    c51rcy1t TEXT,
    c51rcy1f INTEGER,
    c51rcz1i INTEGER
    , CONSTRAINT c51r_unq1 UNIQUE (c51rb21f, c51rc11s, _vsn)
  );

  -- 団体用ホーム画面説明文
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00010100', 'お知らせはありません。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 団体用ホーム画面直接予約文１・２・３
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00020100', 'エントリー抽選後の空き室・設備を先着順で予約', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00020200', '予約対象：翌々月までの空き枠
（翌々月についてのWEB直接予約は22日21:00から）
時期により予約できる件数に制限があります。詳しくは利用ガイドをご確認ください。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 団体用ホーム画面エントリー文１・２・３
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00030100', '翌々月に使用する室・設備の予約抽選', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00030200', '受付：毎月1日〜10日
抽選結果発表：その月の17日 12:00
エントリーは地区センター枚に1団体2件までです', 9999, '2000-01-01 00:00:00', 1, 10);

  -- ホーム画面設定説明文１・２
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00040100', 'メールアドレスの変更', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00040200', '', 9999, '2000-01-01 00:00:00', 1, 10);

  -- メール署名・利用規約の表記・設備の使用
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00050100', '-------------------------------------------------
【施設住所・連絡先】
〒000-0000　横浜市◯◯区〇〇
横浜市◯◯地区センター
開館：　9時～21時 日・祝は17時迄
休館日：　毎月第３月曜日(祝日の場合は翌日)
　　　　　年末年始（12/28～1/4）
Tel：　000-000-0000　　Fax：　000-000-0000
-------------------------------------------------
指定管理者：　一般社団法人◯◯施設協会', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00050200', '', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00050310', '10', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00060100', '利用規約', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00070100', '10', 9999, '2000-01-01 00:00:00', 1, 10);

  -- ログイン画面説明文
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00080100', 'お知らせはありません。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00080200', '10', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 団体用ホーム画面優先エントリー文１・２・３
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00090100', '３ヶ月後に使用する室・設備の予約抽選', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00090200', '受付：毎月1日〜10日
  抽選結果発表：その月の17日 12:00
  優先エントリーは地区センター枚に1団体2件までです', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 決済を使用
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '00100100', '0', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 直接予約一覧画面説明文１・２
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01010100', '【既存予約の詳細確認やキャンセル】••• 該当する予約のIDを押してください。
【予約申込】••• 画面最下の「新規予約」ボタンを押してください。
　利用日の一週間前を過ぎるとWEBでのキャンセルはできません。
　料金は当日入室前までにお支払いください。お支払い済の予約をキャンセルする場合は、電話か、直接窓口にお越しください。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 直接予約登録画面説明文１・２（新規）
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01020100', '予約情報を入力→「利用規約」を確認後に「利用規約を確認・同意する」をチェック→「登録」ボタンを押してください。
（・枠中のテキストは変更できます。・右肩に×のある欄・・・×で取り消し、それ以外を押すと入力を選択できます）
★一回の申し込みで指定可能な時間帯は、１コマまでです。

【各室の予約状況】・・・希望する「室」と「利用日」を選択すると表示されます。', 9999, '2000-01-01 00:00:00', 1, 10);
  -- UPDATE t_c51r SET c51ri11s = '予約情報を入力→「利用規約」を確認後に「利用規約を確認・同意する」をチェック→「登録」ボタンを押してください。
（・枠中のテキストは変更できます。・右肩に×のある欄・・・×で取り消し、それ以外を押すと入力を選択できます）
★一回の申し込みで指定可能な時間帯は、１コマまでです。

【各室の予約状況】・・・希望する「室」と「利用日」を選択すると表示されます。' WHERE c51rc11s = '01020100';


  -- 直接予約登録画面説明文１・２（変更）

  -- 直接予約登録画面説明文１・２（閲覧）
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01022100', '　予約内容をキャンセルする場合は、キャンセルボタンを押して下さい。利用日の一週間前を過ぎるとWEBでのキャンセルはできません。
　料金は当日入室前までにお支払いください。お支払い済の予約をキャンセルする場合は、電話か、直接窓口にお越しください。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 利用申請書説明文＆色１・２・３
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030100', '次のとおり、利用を申請します。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030101', 'black', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030200', '障害施設を利用される方々の為に、駐車場の利用はできるだけご遠慮ください。
やむを得ない場合は、会場利用申込み時に、駐車希望をご申請ください。 ※1団体1台のみ', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030201', 'red', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030300', '・使用料は3時間を1件として計算します。
・使用時間が3時間に満たない場合も全額支払いが必要です。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01030301', 'black', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 抽選後の予約解禁日・抽選後の予約解禁時刻・キャンセル可能日・予約受付終了日・支払期限基準・支払期限日数
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040100', '22', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040200', '21:00', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040300', '7', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040400', '2', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040500', '10', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '01040600', '0', 9999, '2000-01-01 00:00:00', 1, 10);

  -- エントリー一覧画面説明文１・２
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02010100', '【既存エントリーの詳細確認やキャンセル】••• 該当するエントリーのIDを押してください。
【エントリー申込】••• 画面最下の「新規エントリー」ボタンを押してください。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02020100', 'エントリー情報を入力→「利用規約」を確認後に「利用規約を確認・同意する」をチェック→「登録」ボタンを押してください。
（・枠中のテキストは変更できます。・右肩に×のある欄・・・×で取り消し、それ以外を押すと入力を選択できます）
★一回の申し込みで指定可能な時間帯は、１コマまでです。

【各室のエントリー状況】・・・希望する「室」と「利用日」を選択すると表示されます。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02022100', '　エントリーをキャンセルする場合は、キャンセルボタンを押して下さい。エントリーのキャンセルは、エントリー受付期間中のみ可能です。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- エントリー受付開始日・エントリー受付終了日・エントリー可能件数
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02040100', '1', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02040200', '31', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '02040300', '99', 9999, '2000-01-01 00:00:00', 1, 10);

  -- エントリー抽選結果公開日・抽選結果公開時刻
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '03010100', '17', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '03010200', '12:00', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '03020100', '', 9999, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  -- VALUES (1, 1, 1, '03020200', '', 9999, '2000-01-01 00:00:00', 1, 10);

  -- サイネージ表示文
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '04010100', '2021年12月28日から2022年01月04日までは休館日です。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 団体用設定画面文言
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '05010100', '', 9999, '2000-01-01 00:00:00', 1, 10);


  -- 優先エントリー一覧画面説明文１・２
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06010100', '【既存優先エントリーの詳細確認やキャンセル】••• 該当する優先エントリーのIDを押してください。
  【優先エントリー申込】••• 画面最下の「新規優先エントリー」ボタンを押してください。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06020100', '優先エントリー情報を入力→「利用規約」を確認後に「利用規約を確認・同意する」をチェック→「登録」ボタンを押してください。
  （・枠中のテキストは変更できます。・右肩に×のある欄・・・×で取り消し、それ以外を押すと入力を選択できます）
  ★一回の申し込みで指定可能な時間帯は、１コマまでです。

  【各室の優先エントリー状況】・・・希望する「室」と「利用日」を選択すると表示されます。', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06022100', '　優先エントリーをキャンセルする場合は、キャンセルボタンを押して下さい。優先エントリーのキャンセルは、優先エントリー受付期間中のみ可能です。', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 優先エントリー受付開始日・エントリー受付終了日・エントリー可能件数
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06040100', '1', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06040200', '31', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '06040300', '99', 9999, '2000-01-01 00:00:00', 1, 10);

  -- 優先エントリー抽選結果公開日・抽選結果公開時刻
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '07010100', '17', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '07010200', '12:00', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  VALUES (1, 1, 1, '07020100', '', 9999, '2000-01-01 00:00:00', 1, 10);
  -- INSERT INTO t_c51r (_vsn, _ltt, c51rb21f, c51rc11s, c51ri11s, c51rcx1i, c51rcy1t, c51rcy1f, c51rcz1i) 
  -- VALUES (1, 1, 1, '07020200', '', 9999, '2000-01-01 00:00:00', 1, 10);

  -- UPDATE t_c51r SET _fst = _key WHERE c51rc11s = '05010100';
  UPDATE t_c51r SET _fst = _key;

*/

  c51r: {
    0: {
      pfx: '設定値',
      b_vsn: true,
      dd_fldDefss: {
        c51rb21f: { // c20r_fst
          pfx: 'c20r_fst',
          type: 'Inp',
          n_col: 10,
        },
/*
        c51rb51k: { // c50r_key ... c50r から c51 を引用する際に必要
          pfx: 'c50r_fst',
          type: 'Inp',
          n_col: 4,
        },
*/
        c51rc11s: { // c50r_fst
          pfx: '設定項目ID',
          type: 'Inp',
          n_col: 10,
        },
        c51ri11s: {
          pfx: '設定値',
          type: 'Inp',
          n_col: 40,
        },
      },
    }
  },

};

};
